import { req } from '_s/service'

// 免密登陆
export function login(data) {
  return req.post({
    url: '/jeecg-boot/sys/Ulogin',
    data,
  })
}
